/**
 * RouterLink — a TanStack Router `Link` styled as an MUI `Link`.
 *
 * `createLink` wires the MUI Link's rendering through the router so navigation
 * is client-side (SPA) and `to` / `params` / `search` are fully type-checked,
 * avoiding the `component={Link}` overload friction between MUI and the router.
 */
import MuiLink from "@mui/material/Link";
import { createLink } from "@tanstack/react-router";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

const MuiLinkForwardRef = forwardRef<
  HTMLAnchorElement,
  Omit<ComponentPropsWithoutRef<typeof MuiLink>, "href">
>(function MuiLinkForwardRef(props, ref) {
  return <MuiLink ref={ref} {...props} />;
});

export const RouterLink = createLink(MuiLinkForwardRef);
